export const API = "https://calcpile.ru/strapi";
export const URL = "https://calcpile.ru";
export const AUTH_TOKEN = "authToken";
export const BEARER = "Bearer";